import {
  ChangeDetectionStrategy,
  Component,
  computed,
  input,
} from '@angular/core';

export type FormLineWidthVariant = 'quarter' | 'half' | 'full';

@Component({
  selector: 'app-form-line',
  templateUrl: './form-line.component.html',
  styleUrl: './form-line.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class FormLineComponent {
  readonly widthVariant = input<FormLineWidthVariant>('half');

  protected readonly isFullWidth = computed(
    () => this.widthVariant() === 'full',
  );

  protected readonly isQuarterWidth = computed(
    () => this.widthVariant() === 'quarter',
  );
}
